import React, { useState } from "react";
import { FloatButton } from "antd";
import styles from "./style.module.scss";
import VLPopover from "../VLPopover";
import VLFloatButton from "../Buttons/VLFloatButton";
import MultiSelect from "views/uikit/FormFields/SelectList";
import { ActionItem } from "views/pages/DataPage/CardsView/DataList";

export interface VLFloatGroupProps {
  actionList: ActionItem[];
  placement?: "topLeft" | "topRight" | "bottomLeft" | "bottomRight";
  tooltipPlacement?: "top" | "bottom" | "left" | "right";
  buttonSize?: "medium" | "large";
}

const VLFloatGroup: React.FC<VLFloatGroupProps> = ({
  actionList,
  placement = "topRight",
  tooltipPlacement = "top",
  buttonSize = "medium",
}) => {
  // Track which popover is open to control tooltip visibility
  const [openPopoverIndex, setOpenPopoverIndex] = useState<number | null>(null);

  const handlePopoverOpenChange = (open: boolean, index: number) => {
    setOpenPopoverIndex(open ? index : null);
  };

  return (
    <FloatButton.Group
      type="primary"
      shape="square"
      className={styles.actionList}
      data-testid="vl-float-group"
    >
      {actionList.map((item: ActionItem, actionIndex: number) => (
        <div
          key={actionIndex}
          className={styles.actionItem}
          data-testid={`vl-float-group-item-${actionIndex}`}
        >
          <VLPopover
            placement={placement}
            trigger={"click"}
            open={openPopoverIndex === actionIndex}
            onOpenChange={(open) => handlePopoverOpenChange(open, actionIndex)}
            content={
              item.subAction ? (
                <div
                  className={styles.multiSelectDropdown}
                  data-testid="vl-float-group-multiselect-wrapper"
                >
                  <MultiSelect
                    options={item.subAction.options}
                    placement={placement}
                    placeholder="Please select"
                    onChange={(e) => {
                      item?.subAction?.onChange?.(e);
                    }}
                  />
                </div>
              ) : undefined
            }
          >
            <VLFloatButton
              icon={item.action.icon}
              onClick={item.action.onClick}
              color={item.action.color}
              tooltip={openPopoverIndex !== actionIndex ? item.tooltip : ""}
              tooltipPlacement={tooltipPlacement}
              buttonSize={buttonSize}
            />
          </VLPopover>
        </div>
      ))}
    </FloatButton.Group>
  );
};

export default VLFloatGroup;
